import {
  GET_BOOK_DIMENSIONS,
  LOAD_BOOK_DIMENSIONS } from './../../action-types/bookproperties';

export const STATE_KEY = 'dimensions';

export const dimensions = (state = {
  margin: {
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
  },
  pageHeight: 0,
  pageWidth: 0,
  layoutHeight: 0,
}, action) => {
  switch (action.type) {
    case GET_BOOK_DIMENSIONS: {
      // landscape: 225, portrait: 305, square: 300
      const { dimensions } = action;
      let layoutHeight = 305;
      if (dimensions.pageWidth / 2 === dimensions.pageHeight) {
        layoutHeight = 300;
      } else if (dimensions.pageHeight / dimensions.pageWidth < 0.5) {
        layoutHeight = 225;
      }

      return Object.assign({}, dimensions, { layoutHeight });
    }

    case LOAD_BOOK_DIMENSIONS: {
      return Object.assign({}, state, action.state);
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/dimensions.js